// extracted by mini-css-extract-plugin
export default {"container":"KD5kKEi6B_wfUvBoudpP","icon":"RGyxXuI6OMpOuO_L16EA"};